import { useState } from "react";
import { useAlert } from "react-alert";
import api from "../../api";
import calculatorImg from "../../images/calculatorImg.png";

export const BTCCalculator = () => {
  const alert = useAlert();
  const [data, setData] = useState({
    amount: 100,
  });
  const [loader, setLoader] = useState(false);
  const [calculatedValues, setCalculatedValues] = useState({});

  const onTextChange = (e, AmountVal) => {
    if (AmountVal) {
      setData({ ...data, amount: AmountVal });
    } else {
      setData({ ...data, [e.target.name]: e.target.value });
    }
  };

  const checkData = async () => {
    try {
      if (!data?.date) {
        alert.show("PlEASE ADD DATE.");
        return;
      }
      if (!data?.symbol) {
        alert.show("PLEASE SELECT COIN.");
        return;
      }
      if (!data?.amount) {
        alert.show("PLEASE ENTER AMOUNT.");
        return;
      }
      if (data?.amount < 0) {
        alert.show("AMOUNT MUST BE GREATER THAN 0.");
        return;
      }
      setLoader(true);
      let payload = {
        symbol: data?.symbol,
        date: data?.date,
      };
      const res = await api.getCoinCalculator(payload);
      // console.log(res);
      if (res?.success) {
        dataCalculations(data?.amount, res?.purchasePrice, res?.currrentPrice);
      }
      setLoader(false);
    } catch (e) {
      if (
        e.message == "server not responding" ||
        e.message == "Network Error"
      ) {
        alert.show("PLEASE TRY AGAIN SHORTLY...");
      } else if (e?.message) {
        alert.show(e?.message || "Too many requests. Please wait.");
      } else {
        console.log(e?.response?.data);

        alert.show(e?.response?.data || "PLEASE TRY AGAIN SHORTLY...");
      }
      // alert.show("Invalid Credentials or Account not verified");
      setLoader(false);
    }
  };

  const dataCalculations = (initialInvestment, purchasePrice, currentPrice) => {
    const btcBought = initialInvestment / purchasePrice;
    const currentValue = btcBought * currentPrice;
    const profit = currentValue - initialInvestment;
    const returnPct = (profit / initialInvestment) * 100;
    let payload = { btcBought, currentValue, profit, returnPct };
    setCalculatedValues(payload);
  };

  function formatPrice(value) {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: value < 1 ? 4 : 2,
      maximumFractionDigits: value < 1 ? 8 : 2,
    }).format(value);
  }

  return (
    <div className="btcCalculatorSec">
      <h1 className="homeHeading text-center ">
        If I Bought Bitcoin <span>Calculator</span>
      </h1>
      <div className="cCard">
        <div className="cCardInner">
          <div className="row ai-center mb-4">
            <div className="col-md-6">
              <div className="imgDiv">
                <img src={calculatorImg} alt="calculator" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="contact-form signup-form">
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label>Enter the Amount</label>
                      <input
                        onChange={(e) => onTextChange(e)}
                        type="number"
                        name="amount"
                        placeholder="$200"
                        className="form-control ng-dirty ng-invalid ng-touched"
                        value={data?.amount}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div
                      className={
                        data?.amount == 100
                          ? "selectBtn mb-4 active"
                          : "selectBtn mb-4"
                      }
                      onClick={(e) => onTextChange(e, 100)}
                    >
                      $100
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div
                      className={
                        data?.amount == 200
                          ? "selectBtn mb-4 active"
                          : "selectBtn mb-4"
                      }
                      onClick={(e) => onTextChange(e, 200)}
                    >
                      $200
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div
                      className={
                        data?.amount == 300
                          ? "selectBtn mb-4 active"
                          : "selectBtn mb-4"
                      }
                      onClick={(e) => onTextChange(e, 300)}
                    >
                      $300
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-group ">
                      <label>Enter the Date</label>
                      <input
                        onChange={(e) => onTextChange(e)}
                        type="date"
                        name="date"
                        placeholder="date..."
                        className="form-control ng-dirty ng-invalid ng-touched"
                        value={data?.date}
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <label>Select Crypto</label>
                    <div className="form-group position-relative">
                      <i className="fa-solid fa-caret-down  arrowDownIco" />

                      <select
                        name="symbol"
                        onChange={(e) => onTextChange(e)}
                        className="form-control ng-dirty ng-invalid ng-touched"
                      >
                        <option value="">Select currency</option>
                        <option value="btc">BITCOIN</option>
                        <option value="eth">ETHEREUM</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12 text-center mt-4">
                    {loader ? (
                      <button className="themeBtn ">
                        <i
                          className="fa fa-spinner fa-pulse mx-2 mb-1"
                          style={{ position: "relative", top: "-0px" }}
                        ></i>
                        Submit
                      </button>
                    ) : (
                      <button className="themeBtn " onClick={checkData}>
                        Submit
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-sm-6 mb-4">
              <div className="priceCard  ">
                <div className="prCardInner">
                  <div className="title">You would have bought</div>
                  <div className="price">
                    {(calculatedValues?.btcBought &&
                      formatPrice(calculatedValues?.btcBought)) ||
                      0}{" "}
                    {data?.symbol || ""}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 mb-4">
              <div className="priceCard ">
                <div className="prCardInner">
                  <div className="title">It’s now worth</div>
                  <div className="price">
                    ${" "}
                    {(calculatedValues?.currentValue &&
                      formatPrice(calculatedValues?.currentValue)) ||
                      0}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 mb-4">
              <div className="priceCard  ">
                <div className="prCardInner">
                  <div className="title">profit</div>
                  <div className="price">
                    ${" "}
                    {(calculatedValues?.profit &&
                      formatPrice(calculatedValues?.profit)) ||
                      0}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 mb-4">
              <div className="priceCard  ">
                <div className="prCardInner">
                  <div className="title">Return</div>
                  <div className="price">
                    {(calculatedValues?.returnPct &&
                      formatPrice(calculatedValues?.returnPct)) ||
                      0}
                    %
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
